import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(theme => {
  const styles = {};
  // Generate classes for xxl1 – xxl12
  for (let i = 1; i <= 12; i++) {
    styles[`xxl${i}`] = {
      [theme.breakpoints.up('xxl')]: {
        flexBasis: `${(i / 12) * 100}%`,
        maxWidth: `${(i / 12) * 100}%`,
      },
    };
  }
  return styles;
});

export const XXLGrid = ({ xxl, className, ...props }) => {
  const classes = useStyles();
  const xxlClass = xxl ? classes[`xxl${xxl}`] : null;

  return <Grid {...props} className={clsx(className, xxlClass)} />;
};

export default XXLGrid;